'use client';
import * as React from 'react';
import { createContext, useContext, useMemo, useState } from 'react';
import { ClaimContainerType } from '../interface';

export interface ModalStateContextType {
  modalState: ClaimContainerType;
  setModalState(f: ClaimContainerType | ((prev: ClaimContainerType) => ClaimContainerType)): void;
}

const ModalStateContext = createContext<ModalStateContextType>({} as ModalStateContextType);

export const useModalState = () => {
  return useContext(ModalStateContext);
};

export const ModalStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [modalState, setModalState] = useState<ClaimContainerType>(ClaimContainerType.EXISTING_WALLET);

  const values = useMemo<ModalStateContextType>(() => {
    return {
      modalState,
      setModalState
    } as ModalStateContextType;
  }, [modalState, setModalState]);

  return <ModalStateContext.Provider value={values}>{children}</ModalStateContext.Provider>;
};
